import {
  Box,
  Button,
  Column,
  Columns,
  Control,
  Field,
  Modal,
  Section,
  Select,
  Title,
} from "@allxsmith/bestax-bulma";

import React, { useRef, useState } from "react";
import {useReactToPrint} from "react-to-print";
import PrintQuote from "./PrintQuote";

export default function PartSearchModal({ open, setOpen, data }) {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({contentRef:  componentRef});

  const [selectedOption, setSelectedOption] = useState("C2E");
  const [chargeableSelected, setChargeableSelected] = useState(true);
  const [isEstimate, setIsEstimate] = useState(true);

  const onChange = e => {
    let value = e.target.value;
    setSelectedOption(value);
    if(value === "C1E"){
      setChargeableSelected(false);
      setIsEstimate(true);
    }
    else if(value === "C2E"){
      setChargeableSelected(true);
      setIsEstimate(true)
    }
    else if(value === "C1"){
      setChargeableSelected(false);
      setIsEstimate(false);
    }
    else if(value === "C2"){
      setChargeableSelected(true);
      setIsEstimate(false);
    }
  }

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal closeOnBlur active={open} onClose={() => setOpen(false)}>
      <Modal.Content>
        <Section style={{ backgroundColor: "grey" }}>
          <Box>
            <Title>Print Options</Title>
            <Columns isMultiline>
              <Column>
                <Field>
                  <Control>
                    <label className="label">Type</label>
                    <Select
                      onChange={onChange}
                      name="type"
                      value={selectedOption}
                    >
                      <option value={"C2E"}>Customer 2 Estimate</option>
                      <option value={"C2"}>Customer 2</option>
                      <option value={"C1E"}>Customer 1 Estimate</option>
                      <option value={"C1"}>Customer 1</option>
                    </Select>
                  </Control>
                </Field>
              </Column>
            </Columns>
            <Columns isMultiline>
              <Column>
                  <Button color="warning" onClick={handlePrint} isFullWidth>
                    Print Workshop Quote Sheet
                  </Button>
              </Column>
              <Column>
                  <Button color="info" onClick={() => setOpen(false)} isFullWidth>
                    Cancel
                  </Button>
              </Column>
            </Columns>
          </Box>
        </Section>
      </Modal.Content>
      <div style={{ display: "none" }}>
        <div ref={componentRef}>
          <PrintQuote
            chargeable={chargeableSelected}
            data={data}
            estimate={isEstimate}
          />
        </div>
      </div>
    </Modal>
  );
}
